import { UseQueryOptions } from '@tanstack/react-query';

import APIError from 'types/api_error';
import { UserGroup } from 'types/user_group';
import { OffsetPaginated, OffsetPaginationParams } from 'types/pagination';

import { useAPI } from 'hooks/api/useAPI';
import { useAuthenticatedQuery } from 'hooks/api/useAuthenticatedQuery';
import { useHasAccess } from 'hooks/useHasAccess';

type UseUserGroupsOptions = UseQueryOptions<
  OffsetPaginated<UserGroup>,
  APIError
> & {
  params?: OffsetPaginationParams;
};

export function useUserGroups({
  queryKey = ['user-groups'],
  params,
  ...options
}: UseUserGroupsOptions = {}) {
  const { applicationID, client } = useAPI();
  const [hasAccess] = useHasAccess();

  const queryParams = {
    pagination: 'offset',
    page: 1,
    limit: 50,
    ...params,
  };

  return useAuthenticatedQuery(
    [...queryKey, applicationID, queryParams],
    async () => {
      const { data } = await client.get<OffsetPaginated<UserGroup>>(
        `/apps/${applicationID}/user_groups`,
        { params: queryParams }
      );
      return data;
    },
    {
      enabled: hasAccess('notification_rules'),
      ...options,
    }
  );
}
